import { render, staticRenderFns } from "./PublicIdForm.vue?vue&type=template&id=3dd12ef0&scoped=true&"
import script from "./PublicIdForm.vue?vue&type=script&lang=js&"
export * from "./PublicIdForm.vue?vue&type=script&lang=js&"
import style0 from "./PublicIdForm.vue?vue&type=style&index=0&id=3dd12ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd12ef0",
  null
  
)

export default component.exports